export default {
  path: '/fte',
  component: () => import(/* webpackChunkName: "fte" */ './Fte'),
  meta: {
    requiresAuth: true
  }
}
